module.exports = function isFunction (fn) {
  return Object.prototype.toString.call(fn) === '[object Function]'
}



//////////////////
// WEBPACK FOOTER
// ./~/x-is-function/index.js
// module id = 1526
// module chunks = 168707334958949